import React from 'react';
import classes from './ForgotPasswordContent.module.scss';
import logo from '../../media/logo/logoSecondary.png';
import useInput from "../../hooks/use-inputs";
import { useSnackbar } from 'notistack'
import { Link } from 'react-router-dom';
import { forgotPassword } from '../../services';

const EmailFormControl = () => {

  const { enqueueSnackbar } = useSnackbar()

    const {
        value: enteredEmail,
        valueIsValid: enterEmailIsValid,
        hasError: emailInputIsInvalid,
        inputChangeHandler: emailInputChangeHandler,
        inputBlurHandler: emailInputBlurHandler,
        reset: resetEmail,
      } = useInput((value) => value.trim() !== "" && value.includes("@"));

 //Form Validation
  let submitFormValid = false;
  if (enterEmailIsValid) {
    submitFormValid = true;
  }

  const submitHandler = async (event) => {
    event.preventDefault();
    if (!submitFormValid) return;
    try {
      // Normalize email to lowercase before sending to backend.
      // The reset link host is decided by the server, so no `domain` is sent.
      forgotPassword({email: enteredEmail.toLowerCase()}).then((res) => {
        if (res?.message === "Password reset email sent") {
          displaySnackbar("Email sent successfully", "success");
          resetForm();
        } else if (res?.code === 429) {
          displaySnackbar("Too many reset requests. Please wait a while and try again.", "error");
        } else if (res?.code === 400) {
          displaySnackbar(res.message || "Enter a valid email", "error");
        } else {
          // Anything else (including "User not found") gets the same neutral copy so
          // this form cannot be used to test which addresses have an account.
          displaySnackbar("If an account exists for that email, a reset link has been sent.", "info");
          resetForm();
        }
      });

    } catch (error) {
      console.error("An error occurred while submitting the form:", error);
    }
  };

  const displaySnackbar = (message, variant) => {
    enqueueSnackbar(message, {
      variant,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });
  };

  const resetForm = () => {
    resetEmail();
  };


  const formInputClasses = !submitFormValid
    ? `${classes.submit} ${classes.formInvalid} purpleLightBtn`
    : `${classes.submit} purpleLightBtn`;

    return (
        <div className={classes.LoginContainer}>
          <div className={classes.formContainer}>
        <form onSubmit={submitHandler} className={classes.form}>
          <div className={classes.logo}>
            <img src={logo} alt="logo" />
          </div>
        <h1 className={classes.title}>Forgot Password</h1>
        <p className={classes.subtitle}>Enter your email to reset your password</p>
        <div className={classes.box}>
          <div className={classes.emailContainer}>
            <label htmlFor="email">Email </label>
            <input
              id="email"
              type="email"
              placeholder='Enter your email'
              value={enteredEmail}
              onChange={emailInputChangeHandler}
              onBlur={emailInputBlurHandler}
            />
              {emailInputIsInvalid && <p className={`${classes.invalid} ${emailInputIsInvalid ? `${classes.isVisible}` : ''}`}>
                          Enter Valid Email
              </p>}
          </div>
          <button
            type="submit"
            className={`${formInputClasses} ${classes.signInBtn}`}
            disabled={!submitFormValid}
          >
            Reset Password
          </button>
        </div>
        <div className={classes.backToLogin}>
          <Link to="/login">
            <i className="fas fa-arrow-left"></i>
            Back to Login
          </Link>
        </div>
      </form>
          </div>
          {/* <div className={classes.bottomText}>
            © Copyright 2025 All Rights Reserved Magic Motorsports
          </div>  */}
        </div>
    )
}

export default EmailFormControl;